import { Box, Stack, Typography, useTheme } from "@mui/material";
import Lottie from "lottie-react";
import redirectAnimation from "../../assets/lottie/redirectLoading.json";
import { Button } from "components";

export const RedirectToDomainLoader = ({
  isVanity,
  heading = "Redirecting to your login portal...",
  tagline = "Looks like you tried signing in from a different link. Please re-enter your credentials to continue.",
  showCta = false,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonLabel = "Open IT-Connect Portal",
  secondaryButtonLabel = "Logout",
}: {
  isVanity: boolean;
  heading?: string;
  tagline?: string;
  showCta?: boolean;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: -1,
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.darkBg.main,
          angle: "0 deg",
        }}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 100% 100%"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.6" filter="url(#filter0_f_6661_28146)">
            <path
              d="M549 370.73C446.2 646.73 20.1667 766.397 -180 791.73V1221.23C66.1667 1249.56 593.3 1222.23 732.5 886.23C957.7 249.83 1417.67 95.0638 1619.5 97.2305L1611 -329.27C1002.5 -348.77 677.5 25.7303 549 370.73Z"
              fill="url(#paint0_radial_6661_28146)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_6661_28146"
              x="-300"
              y="-450"
              width="2039.5"
              height="1799.64"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="60"
                result="effect1_foregroundBlur_6661_28146"
              />
            </filter>
            <radialGradient
              id="paint0_radial_6661_28146"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(719.75 449.822) rotate(90) scale(747.678 862.662)"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="#EFD3FC" />
            </radialGradient>
          </defs>
        </svg>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          justifyContent: "center",
          height: "fit-content",
          width: "min(480px, 90%)",
          padding: "40px",
          borderRadius: "16px",
          boxShadow:
            "0px 7.88px 16.88px 0px #0000000A, 0px 127.13px 50.63px 0px #00000003",
          backgroundColor: theme.palette.darkBg.main,
          gap: "8px",
        }}
      >
        <Lottie
          animationData={redirectAnimation}
          alt="logo"
          style={{
            width: "108px",
            height: "80px",
          }}
        />

        <Typography variant="h5">{heading}</Typography>
        <Typography
          variant="body-medium"
          sx={{ color: theme.palette.lightBg.low }}
        >
          {tagline}
        </Typography>
        {showCta && (
          <Stack direction={"row"} gap="12px" justifyContent={"flex-end"}>
            <Button
              sx={{ mt: "16px" }}
              variant="secondary"
              fullWidth
              onClick={onSecondaryButtonClick}
            >
              {secondaryButtonLabel}
            </Button>
            <Button
              sx={{ mt: "16px" }}
              variant="primary"
              fullWidth
              onClick={onPrimaryButtonClick}
            >
              {primaryButtonLabel}
            </Button>
          </Stack>
        )}
      </Box>
    </Box>
  );
};
